import { Injectable } from "@angular/core";
import { InspectionViolation } from "../types/Violation/InspectionViolation";
import { arrayReplace } from "../../utils";
import { InspectionRepository } from "./inspection.repository";

@Injectable({
  providedIn: "root",
})
export class InspectionViolationRepository extends InspectionRepository {
  public async addInspectionViolation(
    locationID: string,
    inspectionID: string,
    violation: InspectionViolation,
  ): Promise<InspectionViolation[]> {
    const inspections = super.getInspectionsByLocationID(locationID);
    const inspection = inspections[inspectionID];
    const violations = inspection?.violations || [];
    const res = await super.saveInspection({
      ...inspection,
      violations: [...violations, violation],
    });
    return res[inspectionID].violations;
  }

  public async updateInspectionViolation(
    locationID: string,
    inspectionID: string,
    index: number,
    violation: InspectionViolation,
  ): Promise<any[]> {
    const inspections = super.getInspectionsByLocationID(locationID);
    const inspection = inspections[inspectionID];
    const violations = inspection?.violations || [];
    const res = await super.saveInspection({
      ...inspection,
      violations: arrayReplace(violations, index, violation),
    });
    return res[inspectionID].violations;
  }

  public saveInspectionViolation(
    locationID: string,
    inspectionID: string,
    violation: InspectionViolation,
  ): Promise<InspectionViolation[]> {
    const violations = this.getInspectionViolationsByInspectionID(
      locationID,
      inspectionID,
    );
    const index = violations.findIndex((item: any) => {
      return item.violationID === violation.violationID;
    });
    if (index > -1) {
      return this.updateInspectionViolation(
        locationID,
        inspectionID,
        index,
        violation,
      );
    }
    return this.addInspectionViolation(locationID, inspectionID, violation);
  }

  public async removeInspectionViolations(
    locationID: string,
    inspectionID: string,
    violationIDs: string[],
  ): Promise<any[]> {
    const inspections = super.getInspectionsByLocationID(locationID);
    const inspection = inspections[inspectionID];
    const violations = inspection?.violations || [];
    const updatedViolations = violations.filter((item: any) => {
      return !violationIDs.includes(item.violationID);
    });
    await this.saveInspection({
      ...inspection,
      violations: updatedViolations,
    });
    return updatedViolations;
  }

  public getInspectionViolationsByInspectionID(
    locationID: string,
    inspectionID: string,
  ): InspectionViolation[] {
    const inspections = super.getInspectionsByLocationID(locationID);
    return inspections[inspectionID]?.violations || [];
  }

  public getInspectionViolationByID(
    locationID: string,
    inspectionID: string,
    violationID: string,
  ): InspectionViolation {
    return this.searchInspectionViolations(
      locationID,
      inspectionID,
      ["violationID"],
      [violationID],
    )[0];
  }

  public getInspectionViolationsByItemID(
    locationID: string,
    inspectionID: string,
    itemID: string,
  ): InspectionViolation[] {
    return this.searchInspectionViolations(
      locationID,
      inspectionID,
      ["itemID"],
      [itemID],
    );
  }

  public searchInspectionViolations(
    locationID: string,
    inspectionID: string,
    keys: any,
    values: any,
  ): InspectionViolation[] {
    const inspections = super.getInspectionsByLocationID(locationID);
    const inspection = inspections[inspectionID];
    const violations = inspection?.violations || [];
    return violations.filter((item: any) => {
      return keys.every((key: string, index: number) => {
        return item[key] === values[index];
      });
    });
  }
}
